const suggestions = {
  c: [
    { label: "printf", kind: 2, insertText: 'printf("");' },
    { label: "main", kind: 2, insertText: "int main() {\n\t\n}" },
    { label: "int", kind: 14, insertText: "int" },
    { label: "float", kind: 14, insertText: "float" },
    { label: "char", kind: 14, insertText: "char" },
    { label: "boolean", kind: 14, insertText: "bool;" },
    { label: "true", kind: 13, insertText: "true" },
    { label: "false", kind: 13, insertText: "false" },
    { label: "max", kind: 2, insertText: "max();" },
    { label: "min", kind: 2, insertText: "min();" },
    { label: "array", kind: 25, insertText: "int arr [];" },
    { label: "if", kind: 14, insertText: "if () {\n\t\n}" },
    { label: "for", kind: 25, insertText: "for (int i = 0; i <N;i++) {\n\t\n}" },
    { label: "while", kind: 25, insertText: "while() {\n\t\n}" }
  ],
  
    java: [
      { label: "System.out.println", kind: 2, insertText: 'System.out.println("");' },
      { label: "main", kind: 2, insertText: "public static void main(String[] args) {\n\t\n}" },
      { label: "int", kind: 14, insertText: "int" },
      { label: "String", kind: 14, insertText: 'String";' },
      { label: "boolean", kind: 14, insertText: "boolean" },
      { label: "true", kind: 13, insertText: "true" },
      { label: "false", kind: 13, insertText: "false" },
      { label: "max", kind: 2, insertText: "Math.max(a,b);" },
      { label: "min", kind: 2, insertText: "Math.min(a, b);" },
      { label: "list", kind: 25, insertText: "List<> array_name = new ArrayList<>();" },
      { label: "if", kind: 14, insertText: "if () {\n\t\n}" },
      { label: "for", kind: 25, insertText: "for (int i = 0; i<N; i++) {\n\t}\n}" },
      { label: "while", kind: 25, insertText: "while () {\n\t\n}" },
      { label: "do while", kind: 25, insertText: "do {\n\t\n} while ();" },
    ],

    python: [
      // Functions
      { label: "print", kind: 2, insertText: 'print("")' },
      { label: "input", kind: 2, insertText: 'input("")' },
      { label: "def function", kind: 25, insertText: "def function_name():\n\t" },
      { label: "len", kind: 2, insertText: 'len()' },
      { label: "sorted", kind: 2, insertText: 'sorted()' },
  
      // Variables
      { label: "int", kind: 14, insertText: "int()" },
      { label: "str", kind: 14, insertText: "str()" },
      { label: "bool", kind: 14, insertText: "bool()" },
      { label: "float", kind: 14, insertText: "float()" },
      { label: "list", kind: 14, insertText: "list= []" },
      { label: "dict", kind: 14, insertText: "dict = {}" },
      { label: "set", kind: 14, insertText: "set = set()" },
      { label: "tuple", kind: 14, insertText: "tuple = ()" },
  
      // Constants
      { label: "True", kind: 13, insertText: "True" },
      { label: "False", kind: 13, insertText: "False" },
  
      // Built-in functions
      { label: "max", kind: 2, insertText: "max(a, b})" },
      { label: "min", kind: 2, insertText: "min(a, b)" },
      { label: "sum", kind: 2, insertText: "sum()" },
      { label: "abs", kind: 2, insertText: "abs()" },
      { label: "range", kind: 2, insertText: "range(start, end)" },
  
      // Arrays (Lists)
      { label: "append", kind: 25, insertText: ".append()" },
      { label: "insert", kind: 25, insertText: ".insert(a,b)" },
      { label: "pop", kind: 25, insertText: ".pop()" },
  
      // Control Structures (Conditionals)
      { label: "if", kind: 14, insertText: "if condition:\n\t" },
      { label: "elif", kind: 14, insertText: "elif condition:\n\t" },
      { label: "else", kind: 14, insertText: "else:\n\t" },
  
      // Loops
      { label: "for", kind: 25, insertText: "for item in iterable:\n\t" },
      { label: "while", kind: 25, insertText: "while condition:\n\t" },
  
      // List Comprehensions
      { label: "list comprehension", kind: 25, insertText: "item for item in iterable if condition]" },
  
      // Try-Except for Error Handling
      { label: "try-except", kind: 25, insertText: "try:\n\t code \nexcept as e:\n\t code" },
  
      // Lambda Functions
      { label: "lambda", kind: 2, insertText: "lambda args: expression" },
  
      // Classes
      { label: "class", kind: 25, insertText: "class ClassName:\n\tdef __init__(self, args):\n\t\tself.arg = arg}" },
      { label: "self", kind: 14, insertText: "self" },
  
      // Assertions
      { label: "assert", kind: 2, insertText: "assert condition,error_message}" },
    ],
};
  
  export default suggestions;
